/** Add `org` to a URL that does not already have one, leaving the rest of the query intact. */
export function withOrgSlug(url: string, orgSlug?: string | null): string {
  if (!orgSlug) {
    return url;
  }

  const hashIndex = url.indexOf('#');
  const withoutHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
  const queryIndex = withoutHash.indexOf('?');
  const params = new URLSearchParams(queryIndex === -1 ? '' : withoutHash.slice(queryIndex + 1));
  if (params.has('org')) {
    return url;
  }

  params.set('org', orgSlug);
  const path = queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex);
  return `${path}?${params.toString()}${hash}`;
}

/** Add `org` to a search object without dropping the other params. */
export function searchWithOrg<T extends object>(search: T, orgSlug: string): T & { org: string } {
  return { ...search, org: orgSlug };
}
